export class TotalVOBandVOLYDetailsReq{
	divisionId : number;
	clientCode : string;
	isGrandTotal : number;
	startDate: string;
	endDate: string;
	groupBy: string;
	categoryId: number;
	subCategoryId: number;
}